import { AloftArea } from '@aloft/toolkit-shared';

/**
 * Returns true if `subjectValue` falls within the [min, max] range of `compValues`
 * (inclusive). Requires at least 2 comp values to define a meaningful range - with
 * fewer than 2 comps there's no bracket to speak of, so this returns false.
 */
export const isAreaBracketed = (
  subjectValue: AloftArea | undefined,
  compValues: AloftArea[],
): boolean => {
  if (!subjectValue || compValues.length < 2) return false;

  const maxCompValue = AloftArea.max(compValues);
  const minCompValue = AloftArea.min(compValues);
  if (!maxCompValue || !minCompValue) return false;

  return subjectValue.le(maxCompValue) && subjectValue.ge(minCompValue);
};

/**
 * Same as `isAreaBracketed`, but for plain numeric values (e.g. Actual Age).
 */
export const isNumberBracketed = (
  subjectValue: number | undefined,
  compValues: number[],
): boolean => {
  if (subjectValue === undefined || compValues.length < 2) return false;

  const maxCompValue = Math.max(...compValues);
  const minCompValue = Math.min(...compValues);

  return subjectValue <= maxCompValue && subjectValue >= minCompValue;
};
